/** Owner-facing card title; burned NFTs use a fixed label (English UI). */
export function getOwnerCardDisplayName(card) {
  if (!card) return ''
  if (card.status === 'BURNED') return 'Burned card'
  return card.name?.trim() || 'Untitled card'
}
